function toAmount(data, decimalPlaces = 0) {
  if (!data) return 0;

  return Number(data).toLocaleString("en-US", {
    ...(decimalPlaces
      ? {
          minimumFractionDigits: decimalPlaces,
          maximumFractionDigits: decimalPlaces,
        }
      : {}),
  });
}

function toCurrency(data) {
  if (!data) return 0;

  return new Intl.NumberFormat("id-ID", {
    style: "currency",
    currency: "IDR",
  }).format(data);
}

function toMioBioTio(data, decimalPlaces = 0) {
  if (!data) return 0;

  switch (true) {
    case Math.abs(Number(data)) >= 1.0e12: // Twelve Zeroes for Trillion
      return toAmount(Math.abs(Number(data)) / 1.0e12, decimalPlaces) + " Tn";

    case Math.abs(Number(data)) >= 1.0e9: // Nine Zeroes for Billion
      return toAmount(Math.abs(Number(data)) / 1.0e9, decimalPlaces) + " Bn";

    case Math.abs(Number(data)) >= 1.0e6: // Six Zeroes for Million
      return toAmount(Math.abs(Number(data)) / 1.0e6, decimalPlaces) + " Mn";

    default:
      return toAmount(Math.abs(Number(data)));
  }
}

function toMio(data, decimalPlaces = 2) {
  if (!data) return "0.00 Mn";
  return toAmount(Math.abs(Number(data)) / 1.0e6, decimalPlaces) + " Mn";
}

export const formatNumber = {
  toAmount,
  toCurrency,
  toMioBioTio,
  toMio,
};
